import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationlessLayoutComponent } from './navigationless-layout/navigationless-layout.component';
import { NavigationLayoutComponent } from './navigation-layout/navigation-layout.component';
import { ComponentsModule } from '../components/components.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [NavigationLayoutComponent, NavigationlessLayoutComponent],
  imports: [CommonModule, ComponentsModule, RouterModule],
})
export class LayoutsModule {}
